import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AttToken from '../../../../helpers/attToken';
import { ChecklistType } from '../../../../service/Checklists';
import ServiceTypes, { types } from '../../../../service/ServiceTypes';
import Clients from '../../../../service/Clients';
import Checklists from '../../../../service/Checklists';
import { WarningSpan } from '../../FormStyle';
import { UserContext } from '../../../../context/UserContext';
import { Autocomplete, Button, Skeleton, Stack, TextField } from '@mui/material';
import { trackEventMatomo } from '../../../../helpers/matomo';
import QueryFn from '../../../../helpers/QueryFn';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import GenericAcordonPlaces from '../../../GenericAcordeonPlaces/GenericAcordeonPlaces';

type props = {
  refetchChecklists: Function
  form: ChecklistType,
  setEditModal: Function,
  typeExists: boolean,
  tipoServico: any,
  setTipoServico: Function,
};

const serviceType = new ServiceTypes();
const CustomerService = new Clients();
const ChecklistService = new Checklists();
const queryFn = new QueryFn();

export default function AssociationTab({ form, typeExists, tipoServico, setTipoServico, refetchChecklists }: props) {
  const { t } = useTranslation('translation');

  const { userData } = useContext(UserContext);

  const [cnjsArr, setCnjsArr] = useState<string[]>(form.conjuntosAssociados ? form.conjuntosAssociados || [] : []);

  const unassocaiteFn = async () => {
    try {
      const data = await AttToken();
      if (data) {
        delete form.conjuntosAssociados;
        const teams = await ChecklistService.unassociateType({ ...data, formId: form.id, typeId: !typeExists ? form.tipoServico : tipoServico });
        setTipoServico('');
        refetchChecklists();
        return teams;
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getClients = async () => {
    try {
      const data = await AttToken();
      if (data && typeExists && form.tipoServico) {
        if (!typeExists) return [];
        const teams = await CustomerService.getAllWithSets(data, form.tipoServico);
        return teams;
      } else throw new Error('aaaa');
    } catch (err) {
      console.error(err);
    }
  };

  const getServices = async () => {
    try {
      const token = await AttToken();
      if (token) {
        const body = { ...token, empresa: token.userEmpresa };
        const result = await serviceType.getAllServices(body);
        return result;
      }
    } catch (err) {
      console.log(err);
    }
  };

  const unassociate = queryFn.useMutate('TipoServico', unassocaiteFn);
  const results = queryFn.useFetchMultiple([
    {
      key: 'GET_CLIENTES_CHILDREN',
      fn: getClients,
    },
    {
      key: 'services1',
      fn: getServices,
    }
  ]);

  const isLoading = results?.some((result: any) => result.isPending);
  const isFetching = results?.some((result: any) => result.isFetching);

  useEffect(() => {
    form.conjuntosAssociados = cnjsArr;
  }, [cnjsArr]);

  return (
    isLoading || isFetching
      ? <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <Stack
          width='100%'
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
        >
          <Skeleton variant='rounded' sx={{ width: `${tipoServico ? '75%' : '100%'}` }} height={40} />
          {((tipoServico || !typeExists) && userData.formMigrado) && <Skeleton variant='rounded' width={200} height={40} />}
        </Stack>
        {tipoServico && <Skeleton variant='rounded' height={60} width='100%' />}
      </Stack>
      : <>
        {(isLoading || unassociate.isPending)
          ? <Skeleton variant='rounded' width='100%' height={40} />
          : <Stack
            width='100%'
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
          >
            <Autocomplete
              size='small'
              sx={{ width: `${tipoServico ? '75%' : '100%'}` }}
              onClick={() => trackEventMatomo('modal config form', 'click', 'select', 'seleciona serviço')}
              disabled={form.tipoServico?.length > 0}
              value={tipoServico ? {
                value: tipoServico,
                label: (results[1].data as any[])?.find((ele: types) => ele.tipoId === tipoServico)?.nome
              } : null}
              id="combo-box-demo"
              isOptionEqualToValue={(option, value) => option.value === value.value}
              filterSelectedOptions
              options={
                (results[1].data as any[])
                  ?.sort((a: types, b: types) => { return a.nome > b.nome ? 1 : - 1; })
                  ?.map((ele: types) => ({
                    label: ele.nome,
                    value: ele.tipoId,
                  }))}
              onChange={(event: any, newValue: { label: string, value: string } | null) => {
                if (newValue) {
                  setTipoServico(newValue?.value);
                  form.tipoServico = newValue.value;
                  results[0].refetch();
                }
              }}
              renderOption={(props, option, { selected }) => (
                <li {...props} key={option.value}>
                  <span>{option.label}</span>
                </li>)}
              renderInput={(params) => <TextField {...params} label={t('formDetails.Association.Tipo_de_servico_do_formulario')} />}
            />
            {((tipoServico || !typeExists) && userData.formMigrado) &&
              <Button
                endIcon={<SwapVertIcon />}
                className='button is-danger'
                onClick={() => {
                  trackEventMatomo('modal config form', 'click', 'button', 'desassocia serviço');
                  unassociate.mutate('');
                }}
              >
                {t('formDetails.Association.desassociar')}
              </Button>}
          </Stack>}
        {!typeExists &&
          <WarningSpan style={{ backgroundColor: 'darkred', color: 'white' }}>
            {t('formDetails.Association.O_tipo_de_serviço_que_estava')}
          </WarningSpan>}
        {tipoServico === '' || unassociate.isPending
          ? <h1>{t('formDetails.Association.Por_favor_selecione_serviço')}</h1>
          : <>
            {isLoading || isFetching
              ? <Skeleton variant='rounded' height={40} width={'100%'} />
              : <GenericAcordonPlaces
                isLoading={isLoading || isFetching}
                clients={(results[0].data as any[])}
                conjuntosArray={cnjsArr}
                setConjuntosArray={setCnjsArr} />}
            {(!isLoading && !isFetching) && (results[0].data as any[]).length === 0 &&
              <WarningSpan>
                {t('formDetails.Association.Voce_nao_possui_nenhuma_estrutura')}
              </WarningSpan>
            }
          </>}
      </>
  );
}

